import Seo from "@/components/feature/Seo";
import Hero from "./components/Hero";
import FeaturedSection from "./components/FeaturedSection";
import RankSection from "./components/RankSection";
import GenreSection from "./components/GenreSection";
import LatestSection from "./components/LatestSection";
import NewsSection from "./components/NewsSection";
import BrandBand from "./components/BrandBand";
import FaqSection from "./components/FaqSection";
import CtaSection from "./components/CtaSection";
import { faqList } from "@/mocks/articles";

const siteJsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "樱花漫画",
    url: "https://comicflower.github.io/",
    description: "专注国产漫画的推荐与资讯平台，聚合热门排行、作品分类与深度专题。",
  },
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "樱花漫画",
    url: "https://comicflower.github.io/",
    potentialAction: {
      "@type": "SearchAction",
      target: "https://comicflower.github.io/manga?q={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqList.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  },
];

export default function Home() {
  return (
    <>
      <Seo
        title="樱花漫画 - 国漫推荐与资讯门户"
        description="樱花漫画是专业的国产漫画推荐与资讯平台，聚合热门国漫排行、漫画分类、新作连载动态与深度专题文章。从热血冒险到治愈日常，帮你发现值得追的漫画作品。"
        keywords="樱花漫画,国产漫画,漫画推荐,漫画排行,漫画分类,国漫资讯,漫画专题"
        canonical="https://comicflower.github.io/"
        jsonLd={siteJsonLd}
      />
      <Hero />
      <FeaturedSection />
      <RankSection />
      <GenreSection />
      <LatestSection />
      <NewsSection />
      <BrandBand />
      <FaqSection />
      <CtaSection />
    </>
  );
}